import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";
import "../css/CreateAccount.css";
import { AppContext } from "../context/AppContext";
// import SaraLogo from "../assets/icons/logo.png";
import logo from "../assets/icons/dpboss.png";
import { toast } from "react-toastify";

function CreateAccount() {
  const [username, setUsername] = useState("");
  const [passwordLocal, setPasswordLocal] = useState("");
  const [confirmPassword, setConfirmPassword] =
    useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { setUser, setPassword, mobileNo } =
    useContext(AppContext);
  const navigate = useNavigate();

  const handleNext = async () => {
    const currentMobileNo =
      mobileNo ||
      localStorage.getItem("mobileNo") ||
      localStorage.getItem("lastLoginMobileNo") ||
      "";

    if (currentMobileNo.length !== 10) {
      toast.warn("Please enter your mobile number first.");
      navigate("/enter-mobile", { replace: true });
      return;
    }

    if (!username.trim()) {
      toast.warn("Please enter a username");
      return;
    }

    if (!passwordLocal.trim()) {
      toast.warn("Please enter a password");
      return;
    }

    if (passwordLocal.length < 6) {
      toast.warn(
        "Password must be at least 6 characters long"
      );
      return;
    }

    if (passwordLocal !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setIsLoading(true);

    try {
      const registerRes = await apiClient.post("/user-register", {
        fullName: username.trim(),
        mobileNo: currentMobileNo,
        password: passwordLocal,
        password_confirmation: passwordLocal,
        security_pin: 1234,
        fcmToken: "",
      });

      if (registerRes.data.status === true) {
        const { accessToken, registerId } =
          registerRes.data.info;

        localStorage.removeItem("accessToken");
        localStorage.removeItem("registerId");

        localStorage.setItem(
          "accessToken",
          accessToken
        );
        localStorage.setItem(
          "registerId",
          registerId
        );

        localStorage.setItem("mobileNo", currentMobileNo);
        localStorage.setItem("lastLoginMobileNo", currentMobileNo);

        const profileRes = await apiClient.post(
          "/user-details-by-register-id",
          { registerId }
        );

        if (profileRes.data.status && profileRes.data.info) {
          const userInfo = profileRes.data.info;

          localStorage.setItem(
            "userProfile",
            JSON.stringify(userInfo)
          );
          localStorage.setItem(
            "walletBalance",
            userInfo.walletBalance
          );

          if (setUser) setUser(userInfo);
          if (setPassword) setPassword(passwordLocal);

          toast.success(
            "Account created successfully!"
          );
          navigate("/home", { replace: true });
        } else {
          toast.warn(
            "Account created, but profile load failed."
          );
          navigate("/login-with-mpin");
        }
      } else {
        toast.error(
          registerRes.data.msg ||
            "Registration failed."
        );
      }
    } catch (err) {
      console.error(
        "Register error:",
        err?.response || err
      );
      toast.error(
        "Something went wrong. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mobile-screen-wrapper">
      <div className="top-header">Sign Up</div>

      <p className="signup-subtitle">
        Create your account to get started.
      </p>

      <div className="create-account-page">
        <div className="content-box">
          <div className="logo-image-wrapper">
            <img
              src={logo}
              alt="Logo"
              className="sara-logo-img"
            />
          </div>

          <div className="form-section">
            <div className="input-box">
              <input
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={(e) =>
                  setUsername(e.target.value)
                }
              />
            </div>

            <div className="input-box">
              <input
                type="password"
                placeholder="Enter password"
                value={passwordLocal}
                onChange={(e) =>
                  setPasswordLocal(e.target.value)
                }
              />
            </div>

            <div className="input-box">
              <input
                type="password"
                placeholder="Confirm password"
                value={confirmPassword}
                onChange={(e) =>
                  setConfirmPassword(e.target.value)
                }
              />
            </div>

            <button
              className="ms-btn"
              onClick={handleNext}
              disabled={isLoading}
            >
              {isLoading
                ? "Creating Account..."
                : "Continue"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateAccount;
